<template>
  <!--菜单页面-->
  <div class="Menu">
    <!-- :default-active="isMenuActive" -->
    <el-menu
      :collapse="$store.getters.getIsView"
      :default-active="isMenuActive"
      :default-openeds="isOpeneds"
      @select="handleSelect"
      @open="handleOpen"
      @close="handleClose"
      class="el-menu-vertical-demo"
      :collapse-transition="false"
      :unique-opened="true"
    >
      <div class="menu_title" v-if="$store.getters.getIsAction == 1">
        <span v-if="!$store.getters.getIsView">客户工作台</span>
        <i v-else class="el-icon-monitor"></i>
      </div>
      <div class="menu_title" v-if="$store.getters.getIsAction == 2">
        <span v-if="!$store.getters.getIsView">原料供应商工作台</span>
        <i v-else class="el-icon-monitor"></i>
      </div>
      <div class="menu_title" v-if="$store.getters.getIsAction == 6">
        <span v-if="!$store.getters.getIsView">物资供应商工作台</span>
        <i v-else class="el-icon-monitor"></i>
      </div>
      <div class="menu_title" v-if="$store.getters.getIsAction == 3">
        <span v-if="!$store.getters.getIsView">承运商工作台</span>
        <i v-else class="el-icon-monitor"></i>
      </div>
      <div class="menu_title" v-if="$store.getters.getIsAction == 4">
        <span v-if="!$store.getters.getIsView">企业工作台</span>
        <i v-else class="el-icon-monitor"></i>
      </div>
      <div class="menu_title" v-if="$store.getters.getIsAction == 5">
        <span v-if="!$store.getters.getIsView">用户工作台</span>
        <i v-else class="el-icon-monitor"></i>
      </div>
      <div
        v-for="(items, indexs) in $store.getters.menuDetailList"
        :key="indexs"
      >
        <div v-if="$store.getters.getIsAction == items.path">
          <div
            v-for="(item, index) in items.children"
            :key="index"
            v-show="item.meta.title != '个人中心'"
          >
            <el-submenu :index="item.name" v-if="item.children">
              <template slot="title">
                <!-- <i class="iconfont" v-html="item.meta.icon"></i> -->
                <img class="icon_pic2" :src="item.meta.iconPic" alt="" />
                <span slot="title" v-if="!$store.getters.getIsView">{{
                  item.meta.title
                }}</span>
              </template>
              <el-menu-item
                v-for="(items, indexs) in item.children"
                :index="items.routerPath"
                :key="index + '-' + indexs"
                class="sub-menu display_flex"
              >
                <!-- <i class="iconfont" v-html="items.meta.icon"></i> -->
                <!--二级菜单的图标-->
                <b>·</b>&nbsp;&nbsp;
                <!-- <img class="icon_pic2" :src="items.meta.iconPic" alt=""> -->
                <span>{{ items.meta.title }}</span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item :index="item.routerPath" class="display_flex" v-else>
              <!-- <i class="iconfont" v-html="item.meta.icon"></i> -->
              <img class="icon_pic2" :src="item.meta.iconPic" alt="" />
              <span slot="title">{{ item.meta.title }}</span>
            </el-menu-item>
          </div>
        </div>
      </div>
    </el-menu>
    <div v-if="$store.getters.getIsAction != 5" class="menu_btn">
      <i
        @click="changeGetIsView"
        :class="
          $store.getters.getIsView ? 'el-icon-s-unfold' : 'el-icon-s-fold'
        "
      ></i>
    </div>

    <!-- <whiteSlipPaymentTwo :isDialog="isDialog2"></whiteSlipPaymentTwo> -->
  </div>
</template>
<script>
export default {
  props: ["isMenuActive", "isOpeneds"],
  data() {
    return {
      isDialog2: false,
    };
  },
  methods: {
    handleOpen() {},
    handleClose() {},
    // 折叠展开菜单
    changeGetIsView() {
      let bol = !this.$store.getters.getIsView;
      this.$store.commit("set_is_view", bol);
    },
    handleSelect(path) {
      if (path == "/supplierWorkbench/digitalCertificate") {
        this.$api.user.signManage().then((res) => {
          if (res.code == "200") {
            window.open(res.url, "_blank");
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        if (path.indexOf("?url=") > -1) {
          window.open(path.split("?url=")[1], "_blank");
        } else {
          this.$emit("changeAction", path);
          this.$router.push(path);
        }
      }
      //       if(path=='/supplierWorkbench/maintain'){
      //        window.open('https://test.b-chem.com/spr-web2/entrustSingle/entrustSingleList', '_blank');
      //       }else{
      //       this.$emit('changeAction',path)
      //       }
    },
  },
  mounted() {},
  // watch:{
  //   isMenuActive:{
  //     handler:function(val){
  //       this.isMenuActive = val
  //     },
  //     immediate:true
  //   }
  // }
};
</script>
<style scoped>
.menu_title {
  height: 56px;
  line-height: 56px;
  text-indent: 20px;
  color: #004593;
  font-weight: 700;
  font-size: 14px;
  /* overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; */
}
.menu_title i {
  display: inline;
  font-weight: bold;
}
.Menu {
  height: calc(100vh - 60px);
  position: relative;
}
/* 加过渡给侧边导航*/
.el-aside {
  transition: width 0.25s;
  -webkit-transition: width 0.25s;
  -moz-transition: width 0.25s;
  -webkit-transition: width 0.25s;
  -o-transition: width 0.25s;
}
/*加快侧边栏文字消失的速度*/
.el-menu {
  height: 100%;
  transition: all 10ms;
  position: relative;
  overflow-y: auto;
}
::v-deep .el-menu {
  background-color: #f2f6f7 !important;
}
.menu_btn {
  position: absolute;
  right: 10px;
  /* bottom: 80px !important; */
  bottom: 0;
  font-size: 28px;
  color: #999;
  cursor: pointer;
}
.Menu ::v-deep .el-icon-arrow-right:before {
  display: none;
}
/* .el-menu-item:focus, .el-menu-item:hover {
    background-color: #E8E9F0;
}
::v-deep .el-submenu__title:hover {
    background-color: #E8E9F0;
} */
.is-active {
  background-color: #f2f6f7;
}
</style>
